// 10 ms RMS windows preserve short consonants; only long silences split phrases.
export function detectSegments(channels, sampleRate, { threshold = -40, gap = 0.55, before = 0.2, after = 0.55, minimum = 1.54 } = {}) {
  const length = channels[0].length;
  const duration = length / sampleRate;
  const windowSize = Math.max(1, Math.round(sampleRate * 0.01));
  const level = Math.pow(10, threshold / 20);
  const regions = [];
  let start = null, last = 0;
  for (let i = 0; i < length; i += windowSize) {
    let peakRms = 0;
    for (const channel of channels) {
      let sum = 0;
      const end = Math.min(i + windowSize, length);
      for (let j = i; j < end; j++) sum += channel[j] * channel[j];
      peakRms = Math.max(peakRms, Math.sqrt(sum / (end - i)));
    }
    if (peakRms >= level) {
      if (start === null) start = i / sampleRate;
      last = Math.min(i + windowSize, length) / sampleRate;
    } else if (start !== null && i / sampleRate - last >= gap) {
      if (last - start >= 0.08) regions.push({ speechStart: start, speechEnd: last });
      start = null;
    }
  }
  if (start !== null && last - start >= 0.08) regions.push({ speechStart: start, speechEnd: last });
  return regions.map((r, i) => {
    const start = Math.max(0, r.speechStart - before, i ? (regions[i - 1].speechEnd + r.speechStart) / 2 : 0);
    return ({
    id: i + 1, name: `fragment_${String(i + 1).padStart(3, '0')}`,
    start,
    end: Math.min(duration, Math.max(r.speechEnd + after, start + minimum), i + 1 < regions.length ? (r.speechEnd + regions[i + 1].speechStart) / 2 : duration),
  });
  });
}

export function safeFilename(name) {
  return name.replace(/[<>:"/\\|?*\u0000-\u001f]/g, '_').replace(/[. ]+$/g, '').trim().slice(0, 150) || 'fragment';
}
export function uniqueFilenames(segments) {
  const used = new Set();
  return segments.map(({ name }) => {
    const base = safeFilename(name);
    let candidate = base, n = 2;
    while (used.has(candidate.toLowerCase())) candidate = `${base} (${n++})`;
    used.add(candidate.toLowerCase());
    return `${candidate}.mp3`;
  });
}
